import http from "@/apis/http";
import url from "@/config/url";

const agentPrivilege = url.tgBusiness.agent.privilege;

export default {
  getColumns: (params) => http.post(agentPrivilege.columns, params),
  getData: (params) => http.post(agentPrivilege.search, params),
  changePrivilege: (params) => http.post(agentPrivilege.action, params),
};
